import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { GetAllParty, GetParty } from "../../../Redux/Party/action";
import { Listitem } from "../../../Redux/Items/action";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import { useForm, useWatch } from "react-hook-form";
import { MdDeleteForever, MdEditNote } from "react-icons/md";
import Select from "react-select";
import PurchaseItemModal from "../Purchase/PurchaseItemModal";
import {
  PrintPurchase,
  PrintPurchaseFail,
  SaleInsert,
  SaleInsertFail,
} from "../../../Redux/Sale/action";
import { ResetIcon } from "@radix-ui/react-icons";
import ItemFetchModal from "./ItemFetchModal";
import PrintIssue from "views/Print/PrintIssue";
import ReactToPrint from "react-to-print";
import { addProperSystemTimeToDate, addSystemTimeToDate } from "../../../utils";
import { formatDate } from "date-fns";

function Sales() {
  const [ChoosedItems, setChoosedItems] = useState([]);
  const [ShowModal, setShowModal] = useState(false);
  const [Qty, setQty] = useState("");
  const [AdvanceAmount, setAdvanceAmount] = useState("");
  const [DiscountAmount, setDiscountAmount] = useState("");
  const [pending, setpending] = useState("");
  const [selectitem, setselectitem] = useState("");
  const [tablelist, setTablelist] = useState([]);
  const [fetchD, setfetchD] = useState(false);
  const [fetchedState, setFetchedState] = useState({
    Date: format(new Date(), "yyyy-MM-dd"),
    SessionName: "",
    SessionId: "",
    IsTransactionExist: "",
  });

  console.log(fetchedState,"fetchedState");
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
    reset,
    setValue,
    watch
  } = useForm({
    defaultValues: {
      DeliveryDate: format(new Date(), "yyyy-MM-dd"),
      AdvanceAmount: "",
      paymentType: "2",
    },
    mode: "all",
  });

  const [fetch, setfetch] = useState(false);
  const handleFetchSuccess = (data) => {
    // setFetchedData(data);
    if (data.length > 0) {
      setfetch(true);
      // if(fetch){

      const Deatils = data.map((item) => ({
        ...item,
        Id: item.ItemId,
      }));

      console.log("ewffew", Deatils);
      setTablelist(Deatils);
      console.log("data", data);

      // }
    }
  };

  const TempleID = JSON.parse(localStorage.getItem("Sopanam_TempleId"));
  const UserId = JSON.parse(localStorage.getItem("Sopanam_UserId"));
  const PartyData = useSelector((state) => state.Party.GetAllPartyData);
  const ItemData = useSelector((state) => state.Items.ListItemData);
  const SaleData = useSelector((state) => state.Sale.SaleData);

  const Dispatch = useDispatch();

  useEffect(() => {
    Dispatch(GetAllParty(TempleID));
    Dispatch(
      Listitem({
        TempleId: TempleID,
      })
    );
  }, []);
  const TotalAmount = tablelist?.reduce(
    (total, item) => total + item.Rate * item.Quantity,
    0
  );
  const HandelClear = () => {
    reset();
    setChoosedItems([]);
    setQty("");
    setselectitem("");
    setTablelist([]);
    setFetchedState({
      Date: format(new Date(), "yyyy-MM-dd"),
      SessionName: "",
      SessionId: "",
      IsTransactionExist: "",
    })
    Dispatch(SaleInsertFail());
    Dispatch(PrintPurchaseFail());
  };

  useEffect(() => {
    if (SaleData.Id > 0 && SaleData.Error == 0) {
      toast.success("Issue success");
      reset();
      setChoosedItems([]);
      setQty("");
      setselectitem("");
      setFetchedState({
        Date: format(new Date(), "yyyy-MM-dd"),
        SessionName: "",
        SessionId: "",
        IsTransactionExist: "",
      })
      setTablelist([]);
    }
  }, [SaleData]);

  const handleitem = (item) => {
    const itemsWithQuantity = { ...item.Item };
    setChoosedItems(itemsWithQuantity);
    setselectitem(item);
    setQty(1);
  };

  const handlecalculation = () => {
    if (Object.keys(ChoosedItems).length > 0) {
      const newItem = {
        ...ChoosedItems,
        Quantity: parseFloat(Qty),
        Discount: parseInt(DiscountAmount) || 0,
      };
      setfetchD(true)
      setTablelist([...tablelist, newItem]);
      setChoosedItems([]);
      setQty("");
      setselectitem("");
    } else {
      alert("Please select Item");
    }
  };

  const handlepending = (adv, dis) => {
    setpending(TotalAmount - dis - adv || TotalAmount);
  };

  const HandelSave = (data) => {
    // e.preventDefault()
    const formattoPayloadate = format(data?.DeliveryDate, "yyyy-MM-dd");
    const utcDate = addProperSystemTimeToDate(data?.DeliveryDate);
    const utcOrder=addProperSystemTimeToDate(fetchedState?.Date)
    console.log("clicked", data);
    if (fetch&&data.party) {
      setfetch(false);
    }
    if (data.party && data.paymentType) {
      if (tablelist.length) {
        let partyid =
          PartyData && PartyData.find((item) => item.Id == data.party);
        let partyname = partyid ? partyid.Name : "";

        
    // Check for blocked items (IsTransactionExist === 1)
    const blockedItems = tablelist?.filter(
      (item) => item.IsTransactionExist === 1
  );

  if (blockedItems?.length > 0) {
      const itemNames = blockedItems.map((item) => item.Name).join(", ");
      toast.error(`Cannot proceed. These items are already issued: ${itemNames}`);
      return;
  }
  // Check for items where Quantity exceeds fetchedQuantity
const exceededItems = tablelist?.filter(
  (item) => parseFloat(item.Quantity) > parseFloat(item.fetchedQuantity)
);

if (exceededItems?.length > 0) {
  const itemNames = exceededItems.map((item) => item.Name).join(", ");
  toast.error(`Cannot proceed. Quantity exceeds fetched limit for: ${itemNames}`);
  return;
}
        if (fetchedState?.IsTransactionExist == 1) {
          toast.error("Already issued on this date");
        } else {
          Dispatch(
            SaleInsert({
              Id: 0,
              BillAmount: TotalAmount || 0,
              BarcodeNumber: "",
              BillDate: utcDate,
              AdvanceAmount: parseInt(AdvanceAmount) || 0,
              PartyId: data.party,
              PartyName: partyname,
              Payment: data.paymentType,
              Discount: parseInt(DiscountAmount) || 0,
              Tax: 0,
              Remarks: data.remarks,
              UserId: UserId,
              TId: 0,
              Amount: TotalAmount || 0,
              OrderDate:fetch? utcOrder:utcDate,
              DeliveryDate: utcDate,
              BillType: 0,
              BillStatus: 0,
              TransactionItems: tablelist,
              AccountingYearId: 4,
              Type: 1,
              InvoiceNo: "",
              InvoiceDate: utcDate,
              Uploads: "",
              TempleId: TempleID,
            })
          );
        }
      } else {
        alert("Please select items to proceed..");
      }
    } else {
      alert("Please select the party And payment Type ");
    }
  };

  const [showfetchmodal, setshowfetchmodal] = useState(false);
  const [editingIndex, setEditingIndex] = useState(-1);
  const handelfetchmodal = () => {
    // setfetch(!fetch)
    setshowfetchmodal(!showfetchmodal);
  };

  const componentRef = React.useRef();

  const handleEdit = (index) => {
    setEditingIndex(index);
  };

  const onHandleFetchedState = (data) => {
    setFetchedState(data);
  };
  useEffect(() => {
    setValue("DeliveryDate", format(fetchedState?.Date, "yyyy-MM-dd"));
    setValue("SessionId", fetchedState?.SessionId);
    setValue("SessionName", fetchedState?.SessionName);
  }, [fetchedState]);

  // const formattedDate = fetchedState?.Date
  // ? format(parseISO(fetchedState.Date), "dd-MM-yyyy")
  // : "";

  const selectedParty = watch("party");
  console.log("selectedParty", selectedParty);
  
  return (
    <div>
      <PrintIssue
        ref={componentRef}
        transactionId={SaleData?.insertreturn?.Id}
      />

      {showfetchmodal && (
        <ItemFetchModal
          showfetchmodal={showfetchmodal}
          setshowfetchmodal={setshowfetchmodal}
          onFetchSuccess={handleFetchSuccess}
          // ChoosedItems={ChoosedItems}
          // setChoosedItems={setChoosedItems}
          onHandleFetchedState={onHandleFetchedState}
          selectedParty={selectedParty}
        />
      )}
      {/*  md:h-[600px] */}
      <div className='class="max-w-sm mt-2 overflow-y-auto rounded-lg border border-gray-200 bg-white p-4 shadow dark:border-gray-700 dark:bg-gray-800 min-h-[50vh] max-h-[95vh]'>
        <div className="w-full flex justify-center"><h6 className="text-[33px] capitalize text-navy-700 font-semibold">Issue</h6></div>
        <form onSubmit={handleSubmit(HandelSave)}>
          <div className="container mx-auto">
            <div className="flex justify-between ">
              {!fetchD&&tablelist?.length > 0 ? (
                <div className="flex items-center space-x-4">
                  <span className="flex items-center space-x-4 font-semibold text-black">
                    Fetched date &nbsp;:&nbsp;
                    <p className="text-lg text-[#b11c32]">
                      {fetchedState?.Date
                        ? format(fetchedState?.Date, "dd/MM/yyyy")
                        : ""}
                    </p>
                  </span>
                  <span className="flex items-center space-x-4 font-semibold text-black">
                    Fetched Session &nbsp;:&nbsp;
                    <p className="text-lg text-[#b11c32]">
                      {fetchedState?.SessionName ?? ""}
                    </p>
                  </span>
                </div>
              ) : (
                <div className="flex-1"></div> // Keeps the button at the right
              )}
            </div>
            <div className="mr-2  flex flex-row items-end md:w-full">
              <div className="mr-2 md:w-3/4 ">
                <label
                  for="message"
                  class=" mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                >
                  Party <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("party")}
                  className="block w-full rounded-lg border border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                  id="party"
                >
                  <option value="">Select Party</option>
                  {Array.isArray(PartyData) &&
                    PartyData.length > 0 &&
                    PartyData.map((party) => (
                      <option key={party.Id} value={party.Id}>
                        {party.Name}
                      </option>
                    ))}
                </select>
              </div>
              <button
                type="button"
                disabled={!selectedParty}
                onClick={() => {
                  handelfetchmodal();
                }}
                class="me-2 rounded-lg bg-blue-700 px-5 py-2 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Fetch Items   
              </button>
            </div>

            
            <div className="flex ">
              <div className="mr-2 w-1/2">
                <label
                  for="message"
                  class=" mb-2 mt-2 block text-sm font-medium text-gray-900 dark:text-white"
                >
                  Delivery Date / Bill Date
                </label>
                <input
                  type="date"
                  className=" block w-full rounded-lg   border border border-gray-700 border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                  id=""
                  {...register("DeliveryDate")}
                />
              </div>
              <div className="w-1/2">
                <label
                  for="message"
                  class=" mb-2 mt-2 block text-sm font-medium text-gray-900 dark:text-white"
                >
                  Payment Type <span className="text-red-500">*</span>
                </label>

                <select
                  {...register("paymentType")}
                  className=" block w-full rounded-lg   border border border-gray-700 border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                  id=""
                >
                  <option value="">Select payment method</option>
                  <option value="0">Cash</option>
                  <option value="1">Card</option>
                  <option value="2">Credit</option>
                </select>
              </div>
            </div>
            <div>
              <label
                for="message"
                class="mt-2 block text-sm font-medium text-gray-900 dark:text-white"
              >
                Remarks
              </label>
              <textarea
                id="message "
                {...register("remarks")}
                rows="2"
                class="mb-2 mt-2 block w-full rounded-lg border border border-gray-700 border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                placeholder="Write your Remarks..."
              ></textarea>
            </div>
            <div className=" md:flex  ">
              <div className=" mr-2 md:w-2/6">
                <label
                  for="message"
                  class=" mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                >
                  Items <span className="text-red-500">*</span>
                </label>
                <Select
                  options={
                    ItemData && ItemData.length > 0
                      ? ItemData.map((item) => {
                          return {
                            value: item.Id,
                            label: item.Name,
                            Item: item,
                          };
                        })
                      : []
                  }
                  placeholder="Select Item"
                  value={selectitem}
                  onChange={handleitem}
                  isSearchable={true}
                />
              </div>

              <div className="mr-2 md:w-1/6 ">
                <label
                  for="message"
                  class="  mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                >
                  Quantity <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  className=" block w-full rounded-lg   border border border-gray-700 border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                  value={Qty}
                  onChange={(e) => {
                    setQty(e.target.value);
                  }}
                />
              </div>

              <div className="mr-2 md:w-1/6">
                <label
                  for="message"
                  class=" mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                >
                  Rate <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className=" block w-full rounded-lg   border border border-gray-700 border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                  value={ChoosedItems.Rate || ""}
                  onChange={(e) =>
                    setChoosedItems({ ...ChoosedItems, Rate: e.target.value })
                  }
                />
              </div>
              <div className=" md:flex md:w-2/6">
                <div className="mr-2 md:w-2/3">
                  <label
                    for="message"
                    class=" mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Total Amount
                  </label>
                  <input
                    type="text"
                    className=" block w-full rounded-lg   border border border-gray-700 border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                    value={Qty * ChoosedItems.Rate || ""}
                    readOnly
                  />
                </div>
                <div className="mr-2 md:w-1/3">
                  <button
                    type="button"
                    class="me-2 mt-7 rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    onClick={() => {
                      handlecalculation();
                    }}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
            <div className="style={{ maxHeight: '400px', overflowY: 'auto' }}">

            {tablelist.length > 0 ? (
              <div className="mb-5 mt-7 overflow-x-auto border border-green-300">
                 <div className="overflow-y-auto" style={{ maxHeight: '310px',scrollbarWidth:"thin" }}>
                <table className="min-w-full table-auto divide-y divide-gray-200">
                  <thead className="bg-gray-50  sticky top-0">
                    <tr>
                      <th
                        className="text-large font-xx-large text-black-700 px-8 py-3 text-left uppercase tracking-wider"
                        style={{ width: "40%" }}
                      >
                        <b>Item Name</b>
                      </th>
                      <th
                        className="text-large font-xx-large text-black-700 px-4 py-3 text-left uppercase tracking-wider"
                        style={{ width: "15%" }}
                      >
                        Fetched Quantity
                      </th>
                      <th
                        className="text-large font-xx-large text-black-700 px-4 py-3 text-left uppercase tracking-wider"
                        style={{ width: "15%" }}
                      >
                        Actual Issued
                      </th>
                      {fetch ? (
                        ""
                      ) : (
                        <th
                          className="text-large font-xx-large text-black-700 px-4 py-3 text-left uppercase tracking-wider"
                          style={{ width: "15%" }}
                        >
                          Rate
                        </th>
                      )}
                      {fetch ? (
                        ""
                      ) : (
                        <th
                          className="text-large font-xx-large text-black-700 px-4 py-3 text-left uppercase tracking-wider"
                          style={{ width: "15%" }}
                        >
                          Amount
                        </th>
                      )}
                      <th
                        className="text-large font-xx-large text-black-700 px-6 py-3 text-left uppercase tracking-wider"
                        style={{ width: "15%" }}
                        colSpan="2"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white max-h-96 overflow-y-auto">
                    {tablelist.map((item, index) => {
                      // Initialize fetchedQuantity if not present
                      if (!item.fetchedQuantity) {
                        item.fetchedQuantity = item.Quantity;
                      }
                      const isQuantityExceeded = parseFloat(item.Quantity) > parseFloat(item.fetchedQuantity);
                      const Amount=item.Rate && item.Quantity
                        ? parseFloat(item.Rate) *
                          parseFloat(item.Quantity)
                        : 0
                      return (
                        <tr key={index}>
                          <td className="whitespace-nowrap px-8 py-4">
                            {item.Name} [{item.Unit ? item.Unit : ""}]
                          </td>
                          <td className="whitespace-nowrap px-8 py-4">
                            {/* Display fetchedQuantity */}
                            {!isNaN(parseFloat(item.fetchedQuantity))
                              ? parseFloat(item.fetchedQuantity).toFixed(3)
                              : ""}
                          </td>
                          <td className="whitespace-nowrap px-8 py-4">
                            {editingIndex === index ? (
                              <>
                              <input
                                type="text"
                                value={parseFloat(item.Quantity)?.toFixed(3)}
                                className="block w-full rounded-lg border border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900"
                                onChange={(e) => {
                                  console.log("lofss");
                                  const newTableList = [...tablelist];
                                  newTableList[index].Quantity = parseFloat(e.target.value);
                                  setTablelist(newTableList);
                                }}
                                onKeyDown={(e) => {
                                  // Prevent default Enter key behavior
                                  if (e.keyCode === 13) {
                                    e.preventDefault(); // Prevent form submission if this input is part of a form
                                    e.stopPropagation(); // Stop the event from bubbling up to parent handlers

                                    // If you want to perform additional logic on Enter key press:
                                    const newTableList = [...tablelist];
                                    newTableList[index].Quantity =
                                    parseFloat(e.target.value);
                                    setTablelist(newTableList);
                                  }
                                }}
                              />
                              {isQuantityExceeded && (
                                <p className="mt-1 text-xs text-red-600">Quantity cannot exceed fetched quantity ({parseFloat(item.fetchedQuantity).toFixed(3)}).</p>
                              )}
                              </>
                            ) : (
                              <>
                              {parseFloat(item.Quantity)?.toFixed(3)}
                              {isQuantityExceeded && (
                                <p className="mt-1 text-xs text-red-600">Quantity cannot exceed fetched quantity ({parseFloat(item.fetchedQuantity).toFixed(3)}).</p>
                              )}
                              </>
                            )}
                          </td>

                          {!fetch && (
                            <>
                              <td className="whitespace-nowrap px-4 py-4">
                                {item?.Rate}
                              </td>
                              <td className="whitespace-nowrap px-4 py-4">
                                {parseFloat(Amount).toFixed(2)}
                              </td>
                            </>
                          )}
                          <td className="whitespace-nowrap px-6 py-4">
                            <button
                              type="button"
                              className="text-red-600 hover:text-red-900"
                              onClick={() => {
                                const newItems = [...tablelist];
                                newItems.splice(index, 1);
                                setTablelist(newItems);
                              }}
                            >
                              <MdDeleteForever
                                className="mt-1"
                                style={{ fontSize: "1.5rem" }}
                              />
                            </button>
                            {fetch && (
                              <button
                                type="button"
                                className="text-green-600"
                                onClick={() => handleEdit(index)}
                              >
                                <MdEditNote
                                  className="mt-1"
                                  style={{ fontSize: "1.5rem" }}
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}

                    {/* Additional rows for totals */}
                    {!fetch && (
                      <>
                        <tr>
                          <td colSpan={4} className="mt-1">
                            <div className="mt-5 p-2">
                              <b>Total Amount:</b>{" "}
                            </div>
                          </td>
                          <td>
                            <div className="mt-5 flex justify-center p-2">
                              <b>{parseFloat(TotalAmount).toFixed(2)}</b>{" "}
                            </div>
                          </td>
                        </tr>
                        {/* Additional input fields for Discount, Grand Total, etc. */}
                        {/* ... */}
                      </>
                    )}
                  </tbody>
                </table>
                </div>
              </div>
            ) : null}
            </div>

            <div className="flex  justify-end mt-4">
              {/* <div>
                <button
                  type="button"
                  class="mb-2 rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white me-2 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Print
                </button>
              </div> */}
              <div>
                <button
                  type="submit"
                  class="mb-2 me-2 rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Save
                </button>
              </div>
              <div>
                <button
                  type="button"
                  onClick={HandelClear}
                  class="mb-2 me-2 rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Clear
                </button>
              </div>
              <ReactToPrint
                trigger={() => (
                  <button
                    class="mb-2 me-2 rounded-lg bg-blue-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    type="button"
                    disabled={!SaleData?.insertreturn?.Id}
                  >
                    Print
                  </button>
                )}
                content={() => componentRef.current}
                onAfterPrint={() => {
                  reset();
                  setChoosedItems([]);
                  setQty("");
                  setselectitem("");
                  setTablelist([]);
                  Dispatch(SaleInsertFail());
                  Dispatch(PrintPurchaseFail());
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Sales;
